import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
    _metaPixelInitialized?: boolean
  }
}

const PIXEL_ID = '1703383767307378'

function initPixel() {
  if (window._metaPixelInitialized) return
  window._metaPixelInitialized = true

  // Create fbq stub that queues calls until the real script loads
  if (!window.fbq) {
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args)
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = [] as any[]
    window.fbq = fbq
    window._fbq = fbq
  }

  // Initialize pixel and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Inject the Facebook SDK script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
  }, [])
}
